import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import "./hyperPersonalization.scss";

const HyperPersonalization = () => {
  return (
    <Container>
    <Box className="hp-container">
      {/* Header Section */}
      <Box className="hp-header">
       <div className="newcd">
         <Box className="hp-number">2</Box>

        <Typography className="hp-title">
          Hyper-Personalization With Salesforce Data Cloud
        </Typography>
       </div>

        <Typography className="hp-subtitle">
          Customer Experience Is The Key Differentiator In Modern Banking.
          Today’s Customers <br /> Expect Highly Personalized, Seamless Interactions
          Across Every Touchpoint.
        </Typography>

        <Typography className="hp-heading">
          Using Salesforce Data Cloud And Salesforce Marketing Cloud, BFSI
          Organizations Can:
        </Typography>
      </Box>

      {/* Content Section */}
      <Grid container spacing={4} className="hp-content">
        {/* Left List */}
        <Grid item xs={12} md={6}>
          <ul className="hp-list">
            <li>
              Build Unified <span>Customer Profiles</span>
            </li>
            <li>
              Deliver <span>Personalized Financial</span> <br /> Recommendations
            </li>
            <li>
              Orchestrate <span>Customer Journeys</span> <br /> Across Channels
            </li>
            <li>
              Improve <span>Engagement</span> And <br /> <span>Retention</span>
            </li>
          </ul>
        </Grid>

        {/* Right Image */}
        <Grid item xs={12} md={6} className="hp-image-wrapper">
          <Box className="hp-image-box">
            <img src="/images/eins.webp" alt="illustration" />
          </Box>
        </Grid>
      </Grid>

      {/* Bottom Cards */}
      
      
      <Grid container spacing={3} className="hp-bottom">
        <Grid item xs={12} md={6}>
            <Typography className="hp-card-title">UTIL Insight</Typography>
          <Box className="hp-card">
            
            <Typography>
              <span>Personalization</span> Is Critical For Improving BFSI
              Customer Experience.
            </Typography>
          </Box>
        </Grid>
              
        <Grid item xs={12} md={6}>
            <Typography className="hp-card-title">Business Impact</Typography>
          <Box className="hp-card">
      
            <Typography>
              Organizations Move From Generic Engagement To{" "}
              <span>Context-Aware Financial Advisory.</span>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
    </Container>
  );
};

export default HyperPersonalization;
